module.exports = __webpack_public_path__ + "img/31.52d29636.png";